import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../_actions/matchesActions";
import * as profileActions from "../../_actions/profileActions";
import * as appActions from "../../_actions/appActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import { confirmAlert } from "react-confirm-alert";
import getAcceptInvitations from "../../_selectors/matchesSelectors/getAcceptInvitations";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMyInvitationsReceivedCount from "../../_selectors/userSelectors/getMyInvitationsReceivedCount";
class AcceptInvitations extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getAcceptInvitations,
      invitationsCount,
      markAllRead
    } = this.props;
    updateHeader({
      title: "Accept Connect Invitations",
      description: "Invitations sent by members"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Accept Connect Invitations", link: "/search" }
    ]);
    getAcceptInvitations();
    if (invitationsCount > 0) {
      markAllRead();
    }
  }
  componentWillUnmount() {
    const { clearMembers, clearAcceptInvitations } = this.props;
    clearMembers();
    clearAcceptInvitations();
  }
  approveConnected = profile => {
    console.log(profile);
    const {
      toast,
      approve,
      clearAcceptInvitations,
      getAcceptInvitations
    } = this.props;
    const onError = error => {
      toast({ type: "error", message: error });
    };
    const onSuccess = () => {
      toast({
        type: "success",
        message: `Approved ${profile.name}'s request to connect.`
      });
      clearAcceptInvitations();
      getAcceptInvitations();
    };
    approve({ profileId: profile.id, onSuccess, onError });
  };
  rejectConnect = profile => {
    const {
      toast,
      reject,
      clearAcceptInvitations,
      getAcceptInvitations
    } = this.props;
    const onError = error => {
      toast({ type: "error", message: error });
    };
    const onSuccess = () => {
      toast({
        type: "success",
        message: `Rejected ${profile.name}'s request to connect.`
      });
      clearAcceptInvitations();
      getAcceptInvitations();
    };
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You will no longer be able to chat with {profile.name}</p>
            <button onClick={onClose}>No</button>
            <button
              onClick={() => {
                reject({
                  profileId: profile.id,
                  onSuccess,
                  onError
                });
                onClose();
              }}
            >
              Yes, Disconnect!
            </button>
          </div>
        );
      }
    });
  };
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <PageSubTitle center>
                <h3>No Invitations to Accept</h3>
              </PageSubTitle>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer
                    user={result.userId}
                    actionButton
                    onAccept={this.approveConnected}
                    onReject={this.rejectConnect}
                  />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getAcceptInvitations(state),
  lastResult: getMatchesLastResult(state),
  invitationsCount: getMyInvitationsReceivedCount(state)
});

const mapDispatchToProps = dispatch => ({
  getAcceptInvitations: () => dispatch(matchesActions.getAcceptInvitations()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearAcceptInvitations: () =>
    dispatch(matchesActions.clearAcceptInvitations()),
  approve: payload => dispatch(profileActions.approveConnectToMember(payload)),
  reject: payload => dispatch(profileActions.disconnectWithMember(payload)),
  toast: payload => dispatch(appActions.showToast(payload)),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_ACCEPT_INVITATIONS })
      )
    ),
  markAllRead: () => dispatch(matchesActions.markAllInvitationsReceivedAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcceptInvitations);



// WEBPACK FOOTER //
// ./src/_components/AcceptInvitations/index.js